import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { NgbActiveModal, NgbDate, NgbDateAdapter, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import { CustomDateAdapter, CustomDateParserFormatter } from 'src/app/helpers/date-adapters';
import { BracketItemService } from 'src/app/services/bracket-item.service';
import { DuelsRoundService } from 'src/app/services/duels-round.service';

@Component({
  selector: 'app-round-edit-modal',
  templateUrl: './round-edit-modal.component.html',
  styleUrls: ['./round-edit-modal.component.scss'],
  providers: [{ provide: NgbDateAdapter, useClass: CustomDateAdapter },
  { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter }]
})
export class RoundEditModalComponent implements OnInit {
  @Input() id: number = -1;

  public round: any = null;

  public form;

  public scheduledAtDate = null;
  public scheduledAtTime = null;

  constructor(
    private duelsRoundService: DuelsRoundService,
    private bracketItemService: BracketItemService,
    private formBuilder: FormBuilder,
    private activeModal: NgbActiveModal,
  ) {
    this.form = this.formBuilder.group({
      wins_count: [''],
      rating_score: [''],
      place_from: [''],
      place_to: [''],
    });
  }

  ngOnInit(): void {
    this.duelsRoundService.get(this.id).subscribe(round => {
      this.round = round;
      this.serialize();
      this.updateForm();
    });
  }

  serialize() {
    if (this.round.scheduled_at) {
      this.round.scheduled_at = new Date(this.round.scheduled_at);
    }
  }

  updateForm() {
    this.form.controls.wins_count.value = this.round.wins_count;
    this.form.controls.rating_score.value = this.round.rating_score;
    this.form.controls.place_from.value = this.round.place_from;
    this.form.controls.place_to.value = this.round.place_to;
    if (this.round.scheduled_at) {
      this.scheduledAtDate = moment(this.round.scheduled_at).format('DD.MM.YYYY');
      this.scheduledAtTime = {
        hour: this.round.scheduled_at.getHours(),
        minute: this.round.scheduled_at.getMinutes(),
      };
    }
  }


  triggerUpdate() {
    this.bracketItemService.update(this.id);
    if (this.round.duel_series) {
      this.round.duel_series.forEach(ds => {
        this.bracketItemService.update(ds.id);
      });
    }
  }

  save() {
    const scheduled = new Date();
    const splitted = this.scheduledAtDate.split('.');
    scheduled.setDate(splitted[0]);
    scheduled.setMonth(splitted[1] - 1);
    scheduled.setFullYear(splitted[2]);
    scheduled.setHours(this.scheduledAtTime.hour);
    scheduled.setMinutes(this.scheduledAtTime.minute);
    this.duelsRoundService.update(this.id, {
      wins_count: this.form.controls.wins_count.value,
      rating_score: this.form.controls.rating_score.value,
      place_from: this.form.controls.place_from.value,
      place_to: this.form.controls.place_to.value,
      scheduled_at: (new Date(scheduled.getTime() - scheduled.getTimezoneOffset() * 60000)).toISOString(),
    }).subscribe((round) => {
      this.round = round;
      this.serialize();
      this.updateForm();
      this.activeModal.close();
    });
  }

}
